export const marks = {
  volumeUpMark: <i className="fa fa-volume-up"></i>,
  volumeDownMark: <i className="fa fa-volume-down"></i>,
  volumeOffMark: <i className="fa fa-volume-off"></i>,
  playMark: <i className="fa fa-play"></i>,
};